import styled from 'react-emotion'

import vars from 'ui_theme/site/globals/site.variables'

export default styled('div')`
  margin-bottom: ${vars.mini};
`
